import http from "../http-common";
import Cookies from "js-cookie";
import heic2any from "heic2any";

var setdara = [];

export const urlApi = process.env.REACT_APP_URL_API;

const get = (url, id) => {
  if (id === undefined) {
    return http.get(url);
  } else {
    return http.get(url + "/" + id);
  }
};

const baseurl = (pathname) => {
  // if (process.env.NODE_ENV === "development") {
  //   return process.env.PUBLIC_URL + pathname;
  // } else {
  return process.env.REACT_APP_BASE_URL + pathname;
  // }
};

const post = (url, data) => {
  return http.post(url, data);
};

const postWithCancel = (url, data, cancellation) => {
  return http.post(url, data, cancellation);
};

function CallBack(data, status) {
  function onSuccess(success) {
    return success;
  }
  function onError(error) {
    return error;
  }
  try {
    if (status === "input") {
      setdara.push(data);
    } else {
      return onSuccess(setdara);
    }
  } catch (error) {
    return onError(error);
  }
}

const absoluteUrl_module = (pathname) =>
  process.env.REACT_APP_MODULE_URL + pathname;
const absoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;
const absoluteApi = (pathname) => process.env.REACT_APP_URL_API + pathname;
const checkPath = (path, name) => {
  return String(path).replace('https://maxioperation.bbtec.co.th','http://103.40.138.150') + name;
};

const converTypeImage = async (urlPath) => {
  toDataURL(urlPath).then((dataUrl) => {
    var fileData = dataURLtoFile(dataUrl, "imageName.jpg");
    heic2any({ blob: fileData, toType: "image/jpg", quality: 1 }).then(
      (newImage) => {
        const url = URL.createObjectURL(newImage);
        return url;
      }
    );
  });
};
const toDataURL = (url) =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const authUser = () => {
  return {
    token: Cookies.get("OperationToken"),
    userId: Cookies.get("userId"),
    username: Cookies.get("username"),
    companyId: Cookies.get("companyid"),
    operatorId: Cookies.get("operator_id"),
    projectId: Cookies.get("project_id"),
    teamId: Cookies.get("team_id"),
    plantCode: Cookies.get("plantCode"),
    storage: Cookies.get("storage"),
    locale: Cookies.get("locale"),
    userArea: !Cookies.get("userarea")
      ? []
      : Cookies.get("userarea")
          .split(",")
          .filter((f) => !!f),
  };
};

export default {
  get,
  post,
  postWithCancel,
  CallBack,
  absoluteUrl,
  absoluteUrl_module,
  checkPath,
  baseurl,
  absoluteApi,
  converTypeImage,
};
